import { cn } from '@/shared/lib';
import { Button } from '@/shared/ui';

interface IPaginationDotProps {
  active?: boolean;
}

const PaginationDot = ({ active }: IPaginationDotProps) => {
  return (
    <Button
      variant="clean"
      className={cn(
        'h-1 w-1 rounded-[1px] bg-base-100 transition-[width] duration-500 ease-out',
        {
          'w-[30px] bg-contrast-500': active,
        },
      )}
    />
  );
};

interface IPaginationProps {
  className?: string;
  slidesCount: number;
  activeSlide?: number;
  onPaginate: (slide: number) => void;
}

export const Pagination = ({
  className,
  slidesCount,
  activeSlide,
  onPaginate,
}: IPaginationProps) => {
  return (
    <ul
      className={cn(
        'flex list-none items-center justify-center gap-2',
        className,
      )}
    >
      {Array(slidesCount)
        .fill(null)
        .map((_, index) => (
          <li
            key={index}
            className="flex min-h-6 cursor-pointer items-center"
            onClick={onPaginate.bind(null, index)}
          >
            <PaginationDot active={index === activeSlide} />
          </li>
        ))}
    </ul>
  );
};
